import { styled } from 'baseui'

export const SaveArea = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '14px',
  marginLeft: 'auto',
})
